import { z } from 'zod/v4';

import { DesignItemExcelOriginsDictionaryRuntype } from '../assembly';
import { DesignItemOriginDTORuntype, QuantityRuntype } from '../backendTypes';
import { HistoryRecordResponseRuntype } from '../changeHistory';
import { endpoint } from '../http/endpoint';
import { PartAlternativeRuntype, PartSpecificationRuntype } from '../part';
import { DesignItemPartAlternativesRuntype, DesignItemResponseDTONewRuntype } from './designItemBackendTypes';

export const designItemEndpoints = {
    'POST /design-items/bulk': endpoint({
        description: 'Fetches a list of design items given their ID',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({ ids: z.array(z.string()) }),
        responseBody: z.object({
            items: z.array(DesignItemResponseDTONewRuntype),
            excel_lines: DesignItemExcelOriginsDictionaryRuntype,
        }),
    }),
    'POST /design-items/many': endpoint({
        description: 'Creates many design items',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            inputs: z.array(
                z.object({
                    designator: z.string(),
                    assembly: z.string(),
                    quantity: QuantityRuntype.nullable(),
                    notes: z.string(),
                    do_not_place: z.boolean(),
                    part_specification: PartSpecificationRuntype.nullable(),
                    origin: DesignItemOriginDTORuntype.nullable(),
                    is_consigned: z.boolean(),
                    aggregation_key: z.string().nullable(),
                    ignore_package_name_mismatch: z.boolean(),
                    aml_excel_origin_ids: z.array(z.string()),
                }),
            ),
        }),
        responseBody: z.object({
            items: z.array(z.string()),
            aggregation_keys: z.array(z.string()),
        }),
    }),
    'GET /design-items/:designItemId/part-alternatives': endpoint({
        description:
            'Get part alternatives for a design item (and a "bom item" also, since all design items in a bom item have the same part alternatives)',
        pathParams: z.object({ designItemId: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.array(PartAlternativeRuntype),
    }),
    'POST /design-items/part-alternatives/bulk': endpoint({
        description: 'Fetches design-item part alternatives based off the part options',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            ids: z.array(z.string()),
        }),
        responseBody: z.object({
            items: z.array(DesignItemPartAlternativesRuntype),
        }),
    }),
    'POST /design-items/history': endpoint({
        description: 'Fetches the history of a design item',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.object({
            ids: z.array(z.string()),
        }),
        responseBody: z.array(HistoryRecordResponseRuntype),
    }),
};
